var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-card"},[_c('div',{staticClass:"bg"}),_c('b-card',{staticClass:"mb-2 card",style:({minHeight: _vm.height ? `${_vm.height}px`: `auto`}),attrs:{"tag":"article"}},[_c('b-img',{staticClass:"mb-1",attrs:{"src":_vm.logo}}),_c('b-card-text',[_vm._v(_vm._s(_vm.description))]),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }